
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"338","height":"322","viewBox":"0 0 338 322","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M170.012 0c73.574.174 140.153 46.522 161.843 116.717 20.784 67.266-13.215 137.011-70.967 177.389-54.554 38.142-126.141 36.69-180.714-1.425-57.977-40.493-95.1-109.187-74.368-176.731C27.524 45.195 95.894-.174 170.012 0z"}})])
          )
        }
      }
    